// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// editor
import 'react-quill/dist/quill.snow.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

import 'moment/locale/pt-br';

import { MotionLazy } from "./components/animate/motion-lazy";
import { SettingsDrawer, SettingsProvider } from "./components/settings";
import ThemeProvider from "./theme";
import { SnackbarProvider } from './components/snackbar';
import ProgressBar from './components/progress-bar';
import SystemRoutes from './routes/routes';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/user';

const App = () => {

  return (
    <BrowserRouter>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'dark', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'bold', // 'default' | 'bold'
          themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
        }}
      >
        <ThemeProvider>
          <MotionLazy>
            <SnackbarProvider>
              <ProgressBar />
              <SettingsDrawer />
              <UserProvider>
                <SystemRoutes />
              </UserProvider>
            </SnackbarProvider>
          </MotionLazy>
        </ThemeProvider>
      </SettingsProvider>
    </BrowserRouter>
  );

}

export default App;